export default __webpack_public_path__ + "static/media/7700BLEU.1d06015a.pdf";